import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import VoiceSectionPage from '@/components/layout/VoiceSectionPage'
import { useAuth } from '@/contexts/AuthContext'
import { supabase } from '@/supabaseClient'

export default function AtendentesPage() {
  const { getProfileId } = useAuth()
  const profileId = getProfileId()

  const [loading, setLoading] = useState(true)
  const [attendants, setAttendants] = useState([])

  useEffect(() => {
    async function load() {
      if (!profileId) {
        setAttendants([])
        setLoading(false)
        return
      }

      setLoading(true)
      const { data, error } = await supabase
        .from('attendants')
        .select('id, name, email, is_active')
        .eq('profile_id', profileId)
        .order('name', { ascending: true })

      if (error) {
        console.error('[AtendentesPage]', error)
        setAttendants([])
      } else {
        setAttendants(data || [])
      }
      setLoading(false)
    }

    load()
  }, [profileId])

  return (
    <VoiceSectionPage
      title="Atendentes"
      description="Os mesmos atendentes do WappDesk são usados aqui para configuração de ramais e filas."
    >
      <div className="space-y-4">
        <div className="rounded-xl border border-border bg-card p-4 text-sm text-muted-foreground">
          Total: {attendants.length} atendente(s)
        </div>

        <div className="overflow-hidden rounded-xl border border-border bg-card">
          {loading ? (
            <p className="px-4 py-6 text-sm text-muted-foreground">Carregando atendentes...</p>
          ) : attendants.length === 0 ? (
            <p className="px-4 py-6 text-sm text-muted-foreground">Nenhum atendente cadastrado.</p>
          ) : (
            <ul className="divide-y divide-border">
              {attendants.map((att) => (
                <li key={att.id} className="flex items-center justify-between gap-3 px-4 py-3">
                  <div className="min-w-0">
                    <p className="truncate font-medium text-foreground">{att.name || att.email}</p>
                    <p className="truncate text-xs text-muted-foreground">{att.email}</p>
                  </div>
                  <span className={`rounded-full px-2 py-0.5 text-xs ${att.is_active ? 'bg-emerald-500/15 text-emerald-700' : 'bg-slate-500/15 text-slate-700'}`}>
                    {att.is_active ? 'Ativo' : 'Inativo'}
                  </span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="flex justify-end">
          <Link
            to="/ramais"
            className="inline-flex min-h-[44px] items-center rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground"
          >
            Configurar ramais
          </Link>
        </div>
      </div>
    </VoiceSectionPage>
  )
}
